<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="中心仓库" prop="storehouseGuid">
            <customer-storehouse-select
              v-model="editModel.storehouseGuid"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item label="采购门店" prop="storeGuidList">
            <customer-store-select v-model="editModel.storeGuidList" :multiple="true" />
          </el-form-item>
          <el-form-item label="供货单位" prop="supplierGuid">
            <customer-store-supplier-select v-model="editModel.supplierGuid" />
          </el-form-item>
          <template v-if="!!editModel.supplierGuid">
            <el-form-item label="采购清单" prop="itemList">
              <div class="hBox" style="padding: 0px">
                <goods-sku-supplier-select
                  placeholder="从供货单位中添加商品"
                  :supplierGuid="editModel.supplierGuid"
                  :params="goodsSelectParams"
                  :showCostPrice="true"
                >
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getItemBySkuGuid(scope.info.guid)">
                        <el-input
                          type="number"
                          v-model="getItemBySkuGuid(scope.info.guid).purchasePrice"
                          @change="
                            handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))
                          "
                          style="width: 140px; margin-right: 10px"
                          size="small"
                          placeholder="采购单价"
                          :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                          :min="1"
                        >
                          <template slot="prepend">采购价</template>
                        </el-input>
                        <el-input-number
                          type="number"
                          v-model="getItemBySkuGuid(scope.info.guid).purchaseCount"
                          @change="
                            handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))
                          "
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          v-if="!getItemBySkuGuid(scope.info.guid).guid"
                          @click="removeItemClick(getItemBySkuGuid(scope.info.guid))"
                        >
                          移出
                        </el-button>
                        <el-link
                          v-if="getItemBySkuGuid(scope.info.guid).guid"
                          :type="
                            getItemBySkuGuid(scope.info.guid).isDelete
                              ? 'primary'
                              : 'danger'
                          "
                          :underline="false"
                          @click="deleteClick(getItemBySkuGuid(scope.info.guid))"
                        >
                          {{
                            getItemBySkuGuid(scope.info.guid).isDelete
                              ? "取消删除"
                              : "标记删除"
                          }}
                        </el-link>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-supplier-select>
                <goods-sku-select
                  placeholder="从全部商品中选选择"
                  :params="goodsSelectParams"
                  :showCostPrice="true"
                >
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getItemBySkuGuid(scope.info.guid)">
                        <el-input
                          type="number"
                          v-model="getItemBySkuGuid(scope.info.guid).purchasePrice"
                          @change="
                            handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))
                          "
                          style="width: 140px; margin-right: 10px"
                          size="small"
                          placeholder="采购单价"
                          :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                          :min="1"
                        >
                          <template slot="prepend">采购价</template>
                        </el-input>
                        <el-input-number
                          type="number"
                          v-model="getItemBySkuGuid(scope.info.guid).purchaseCount"
                          @change="
                            handleItemGoodsChange(getItemBySkuGuid(scope.info.guid))
                          "
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          v-if="!getItemBySkuGuid(scope.info.guid).guid"
                          @click="removeItemClick(getItemBySkuGuid(scope.info.guid))"
                        >
                          移出
                        </el-button>
                        <el-link
                          v-if="getItemBySkuGuid(scope.info.guid).guid"
                          :type="
                            getItemBySkuGuid(scope.info.guid).isDelete
                              ? 'primary'
                              : 'danger'
                          "
                          :underline="false"
                          @click="deleteClick(getItemBySkuGuid(scope.info.guid))"
                        >
                          {{
                            getItemBySkuGuid(scope.info.guid).isDelete
                              ? "取消删除"
                              : "标记删除"
                          }}
                        </el-link>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-select>
                <upload-file
                  :btnLabel="batchMatchItem ? '批量添加商品' : '上传Excel文件'"
                  :fileSize="10240"
                  :loading="batchMatchItem"
                  :fileTplUrl="'/static/file_tpl/warehouse_purchase_item_list_tpl.xls'"
                  @handleUploadFile="batchMatchItemClick"
                >
                </upload-file>
              </div>
              <div>
                <el-table
                  stripe
                  v-if="editModel.itemList && editModel.itemList.length > 0"
                  :data="editModel.itemList"
                  :cell-class-name="delLine"
                  :size="$xUISize"
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.skuInfo" />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="采购单价" width="180px">
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        :disabled="!!scope.row.isDelete"
                        v-model="scope.row.purchasePrice"
                        @change="handleItemGoodsChange(scope.row)"
                        placeholder="采购单价"
                        style="width: 140px"
                      >
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="采购数量" width="200px">
                    <template slot-scope="scope">
                      <el-input-number
                        :disabled="!!scope.row.isDelete"
                        v-model="scope.row.purchaseCount"
                        @change="handleItemGoodsChange(scope.row)"
                        placeholder="采购数量"
                        style="width: 140px"
                        :min="1"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="建议补货" width="200px">
                    <template slot-scope="scope">
                      <el-input-number
                        :disabled="!!scope.row.isDelete"
                        v-if="scope.row.suggestCount > 0"
                        v-model="scope.row.suggestCount"
                        @change="handleItemGoodsChange(scope.row)"
                        placeholder="建议补货"
                        style="width: 140px"
                        :min="0"
                      ></el-input-number>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!scope.row.guid"
                        @click="removeItemClick(scope.row)"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="scope.row.guid"
                        :type="scope.row.isDelete ? 'primary' : 'danger'"
                        :underline="false"
                        @click="deleteClick(scope.row)"
                      >
                        {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  style="color: #999999; font-size: 14px; margin-top: 20px"
                  v-if="editModel.totalGoodsCount > 0"
                >
                  <span>合计：共</span>
                  <span style="color: #f56c6c">
                    {{ (editModel.itemList && editModel.itemList.length) || 0 }}
                  </span>
                  <span>种</span>
                  <span>（</span>
                  <span style="color: #f56c6c">
                    {{ editModel.totalGoodsCount || 0 }}
                  </span>
                  <span>份商品</span>
                  <span>）</span>
                </div>
                <div v-else style="color: #999999; font-size: 14px; margin-top: 20px">
                  * 请选择商品添加到清单
                </div>
              </div>
            </el-form-item>
            <el-form-item label="采购信息" prop="purchaseOrderRemark">
              <el-input
                type="textarea"
                v-model="editModel.purchaseOrderRemark"
                :rows="2"
                maxlength="256"
                placeholder="输入采购订单信息"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="快递单号" prop="purchaseTrackingNumber">
              <el-input
                type="textarea"
                v-model="editModel.purchaseTrackingNumber"
                :rows="2"
                maxlength="256"
                placeholder="输入快递单号"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="运费金额" prop="freightAmount" key="freightAmount">
              <el-input
                type="number"
                @change="handleItemChange"
                v-model="editModel.freightAmount"
                placeholder="请输入运费金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="实付金额" prop="paymentAmount" key="paymentAmount">
              <el-input
                type="number"
                v-model="editModel.paymentAmount"
                placeholder="请输入实付金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="付款账户" prop="paymentAccount" key="paymentAccount">
              <el-select
                style="width: 100%"
                v-model="editModel.paymentAccount"
                placeholder="请选择付款账户"
              >
                <el-option label="下单未支付" value="下单未支付"> </el-option>
                <el-option label="王文政垫付" value="王文政垫付"> </el-option>
                <el-option label="汲生鑫垫付" value="汲生鑫垫付"> </el-option>
                <el-option label="任天宇垫付" value="任天宇垫付"> </el-option>
                <el-option label="修振垫付" value="修振垫付"> </el-option>
                <el-option label="董明垫付" value="董明垫付"> </el-option>
                <el-option label="公账支付" value="公账支付"> </el-option>
                <el-option label="账期结算" value="账期结算"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算状态" prop="settlementState" key="settlementState">
              <el-select
                style="width: 100%"
                v-model="editModel.settlementState"
                placeholder="请选择结算状态"
              >
                <el-option label="未结算" value="未结算"> </el-option>
                <el-option label="已结算" value="已结算"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注说明" prop="optRemark">
              <el-input
                type="textarea"
                v-model="editModel.optRemark"
                :rows="3"
                maxlength="256"
                placeholder="输入备注说明内容"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div style="color: #999999; font-size: 14px; margin-bottom: 10px">
                合计金额:
                <span style="font-size: 18px; color: #f56c6c">
                  {{ editModel.totalAmount || 0 }}元
                </span>
              </div>
              <el-button
                type="primary"
                :loading="editSubmit"
                :disabled="
                  editSubmit || !editModel.itemList || editModel.itemList.length <= 0
                "
                @click="submitClick"
              >
                提交
              </el-button>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import uploadFile from "../../../../components/uploadFile.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import goodsSkuSupplierSelect from "../../../../components/business/goodsSkuSupplierSelect.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";
import customerStoreSupplierSelect from "../../../../components/business/customerStoreSupplierSelect.vue";
import warehouseReplenishSelect from "../../../../components/business/warehouseReplenishSelect.vue";

const defaultModel = {
  itemList: [],
  paymentAmount: "",
  paymentAccount: "下单未支付",
  storeGuidList: "",
  freightAmount: 0,
  totalAmount: 0,
};

export default {
  components: {
    uploadFile,
    goodsSkuInfo,
    goodsSkuSelect,
    goodsSkuSupplierSelect,
    customerStoreSelect,
    customerStorehouseSelect,
    customerStoreSupplierSelect,
    warehouseReplenishSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    goodsSelectParams() {
      return {
        // optSplit: 0,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      batchMatchItem: false,
      editSubmit: false,
      editModel: null,
      editRules: {
        arrangedGuid: [
          {
            required: true,
            message: "采购计划不能为空",
            trigger: "change",
          },
        ],
        storehouseGuid: [
          {
            required: true,
            message: "中心仓库不能为空",
            trigger: "change",
          },
        ],
        supplierGuid: [
          {
            required: true,
            message: "供货单位不能为空",
            trigger: "change",
          },
        ],
        storeGuidList: [
          {
            required: true,
            message: "采购门店不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    batchMatchItemClick(fileData) {
      if (this.batchMatchItem) {
        return;
      }
      this.batchMatchItem = true;
      this.requestApi(
        "biz.warehouse.purchase.info.batchMatchItem",
        {
          excelBase64: fileData.data,
        },
        {
          timeout: 1000 * 60 * 60 * 24,
          showError: true,
        }
      )
        .then((resp) => {
          this.success("提交成功");
          console.log(resp);
          if (!this.editModel.itemList) {
            this.editModel.itemList = [];
          }
          (resp.data || []).forEach((iitem) => {
            let skuInfo = iitem.skuInfo;
            let flag = false;
            this.editModel.itemList.forEach((i) => {
              if (i.skuGuid == skuInfo.guid) {
                flag = true;
              }
            });
            if (!flag) {
              this.editModel.itemList.unshift({
                skuInfo: skuInfo,
                skuGuid: skuInfo.guid,
                purchasePrice: iitem.purchasePrice || "",
                purchaseCount: iitem.purchaseCount || 1,
                suggestCount: iitem.suggestCount || "",
                isDelete: 0,
              });
            }
          });
          this.handleItemChange();
          this.validate();
        })
        .finally(() => {
          this.batchMatchItem = false;
        });
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleItemGoodsChange(item) {
      if (item.purchaseCount < 0) {
        item.purchaseCount = 0;
      }
      if (item.purchasePrice < 0) {
        item.purchasePrice = 0;
      }
      item.totalAmount = Number(
        Number(item.purchasePrice * item.purchaseCount).toFixed(2)
      );
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.totalAmount = Number(this.editModel.freightAmount) || 0;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.purchaseCount < 0) {
          item.purchaseCount = 0;
        }
        if (item.purchasePrice < 0) {
          item.purchasePrice = 0;
        }
        item.totalAmount = Number(
          Number(item.purchasePrice * item.purchaseCount).toFixed(2)
        );
        if (!item.isDelete) {
          this.editModel.totalAmount += Number(item.totalAmount);
          this.editModel.totalAmount = Number(
            Number(this.editModel.totalAmount).toFixed(2)
          );
        }
      });
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    deleteClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemChange();
    },
    handleAddItem(item) {
      this.requestApi(
        "biz.goods.supplier.info.detailBySku",
        {
          supplierGuid: this.editModel.supplierGuid,
          skuGuid: item.guid,
        },
        {
          showError: false,
        }
      )
        .catch((err) => {
          return {
            data: {},
          };
        })
        .then((resp) => {
          if (!this.editModel.itemList) {
            this.editModel.itemList = [];
          }
          let flag = false;
          this.editModel.itemList.forEach((i) => {
            if (i.skuGuid == item.guid) {
              flag = true;
            }
          });
          if (!flag) {
            this.editModel.itemList.unshift({
              skuInfo: item,
              skuGuid: item.guid,
              purchasePrice: (resp.data && resp.data.purchasePrice) || "",
              purchaseCount: 1,
              suggestCount: "",
              isDelete: 0,
            });
          }
          this.handleItemChange();
          this.validate();
        });
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    copyReplenishItems(purchaseInfo, cancel) {
      this.$confirm("确定使用采购单的商品清单替换？", "确认", {
        type: "info",
      }).then(() => {
        cancel();
        this.editModel.copyGuid = purchaseInfo.guid;
        this.editModel.copyStoreGuid = purchaseInfo.storeGuid;
        this.fetchCopyModel();
      });
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          let method = "biz.warehouse.purchase.info.createBatch";
          this.requestApi(
            method,
            {
              arrangedGuid: this.editModel.arrangedGuid,
              storehouseGuid: this.editModel.storehouseGuid,
              storeGuidList: this.editModel.storeGuidList,
              createParam: this.editModel,
            },
            {
              showError: true,
            }
          )
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.copyGuid) {
        this.editModel.copyGuid = this.pageParams.copyGuid;
      }
      if (this.pageParams.arrangedGuid) {
        this.editModel.arrangedGuid = this.pageParams.arrangedGuid;
      }
      if (this.pageParams.storehouseGuid) {
        this.editModel.storehouseGuid = this.pageParams.storehouseGuid;
      }
      this.fetchCopyModel();
      this.handleItemChange();
    },
    fetchModel() {
      // 新增
      this.editModel = Object.assign({}, defaultModel, {
        itemList: [],
      });
      this.handleModel();
    },
    fetchCopyModel() {
      if (this.editModel.copyGuid) {
        this.loading = true;
        this.errorMsg = null;
        this.requestApi("biz.warehouse.purchase.info.detail", {
          guid: this.editModel.copyGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.purchase.item.list", {
              purchaseGuid: resp.data.guid,
            }).then((listResp) => {
              this.editModel.purchaseOrderRemark = resp.data.purchaseOrderRemark;
              this.editModel.freightAmount = resp.data.freightAmount;
              this.editModel.totalAmount = resp.data.totalAmount;
              this.editModel.itemList = (listResp.data.list || []).map((item) => {
                return {
                  skuInfo: item.skuInfo,
                  skuGuid: item.skuGuid,
                  purchaseCount: item.purchaseCount,
                  purchasePrice: item.purchasePrice || "",
                  suggestCount: item.suggestCount || "",
                  isDelete: 0,
                };
              });
              this.handleItemChange();
            });
          })
          .catch((err) => {
            let errorMessage = (err && err.msg) || (err && err.message) || "数据加载失败";
            this.$confirm(errorMessage, "重试", {
              type: "info",
            })
              .then(() => {
                this.fetchCopyModel();
              })
              .catch((_) => {
                this.$drawer.backDrawer();
              });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
